<template>
    <div>

        <sg-items-block name="Оповещение о необходимости внесения показаний по счетчикам"
            alert="Оповещение будет выслано за день до окончания периода подачи показаний">

            <v-list-item @click="toggleSetting('phone')" :ripple="hasPhone" style="min-height: 56px">
                <v-list-item-content class="d-block">
                    <v-list-item-title>
                        SMS оповещение
                    </v-list-item-title>

                    <v-list-item-subtitle v-if="!hasPhone">
                        Номер телефона не указан
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>

                    <sg-switch v-if="hasPhone" :input-value="userInfo.settings.counterRemind" value="phone"
                        :disabled="!hasPhone" readonly :loading="loadings.phone" />

                    <!--       <v-icon v-else> 
                        mdi-lock
                    </v-icon> -->

                    <v-btn v-else color="primary" small outlined :to="{name: 'wv-settings-phone-edit'}">Указать</v-btn>

                </v-list-item-action>

            </v-list-item>

            <v-divider style="margin-left: 16px"/>

            <v-list-item @click="toggleSetting('email')" :ripple="hasEmail"  style="min-height: 56px">
                <v-list-item-content class="d-block">
                    <v-list-item-title>
                        По электронной почте
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="!hasEmail">
                        Электронная почта не указана
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>

                    <sg-switch v-if="hasEmail" :input-value="userInfo.settings.counterRemind" value="email"
                        :disabled="!hasEmail" readonly :loading="loadings.email" />

                    <!--   <v-icon v-else> 
                        mdi-lock
                    </v-icon> -->

                    <v-btn v-else color="primary" small outlined :to="{name: 'wv-settings-email-edit'}">Указать</v-btn>

                </v-list-item-action>

            </v-list-item>
        </sg-items-block>

        <!--         <v-alert v-if="!hasPhone" type="info" text :icon="false">
            Для того, чтобы иметь возможность получать напоминание по SMS, вам необходимо указать номер телефона.

            <div class="d-flex justify-end mt-3">
                <v-btn color="primary" outlined :to="{name: 'wv-settings-phone-edit'}">Указать</v-btn>
            </div>
        </v-alert>

        <v-alert v-if="!hasEmail" type="info" text :icon="false">
            Для того, чтобы иметь возможность получать напоминание на электронную почту, вам необходимо указать ее адрес.

            <div class="d-flex justify-end mt-3">
                <v-btn color="primary" outlined :to="{name: 'wv-settings-email-edit'}">Указать</v-btn>
            </div>
        </v-alert> -->

        <sg-nav-back-btn class="mt-3"/>


    </div>
</template>

<script>
    import settingsMixin from './settingsMixin'


    export default {
        mixins: [settingsMixin],

        computed: {


            values() {
                return ['phone', 'email'].reduce((map, type) => {



                    map[type] = this.userInfo.settings.counterRemind.includes(type)

                    return map
                }, {})
            }
        },

        data() {
            return {
                loadings: {
                    phone: false,
                    email: false
                },
            }
        },
        methods: {
            toggleSetting(type) {

                if (this.loadings[type]) return

                if (type == 'phone' && !this.hasPhone) return
                if (type == 'email' && !this.hasEmail) return




                let toSend = Object.entries(this.values).filter(entry => entry[1]).map(entry => entry[0])


                if (this.values[type]) {

                    let indexToRemove = toSend.indexOf(type)

                    if (indexToRemove > -1) {

                        toSend.splice(indexToRemove, 1)
                    }

                } else {


                    toSend.push(type)
                }



                this.loadings[type] = true

                /*       this.$store.dispatch('settings/SET_SETTING', { settingName: 'counterRemind', newValue: toSend })
                      .finally(()=> {
                          this.loadings[type] = false
                      }) */


                this.changeSettings('counterRemind', toSend)
                    .finally(() => {
                        this.loadings[type] = false
                    })

            }
        }

    }
</script>

<style>

</style>